export const getMapThumbnailUrl = (id: string, updatedAt: string) =>
	`${process.env.MAP_ASSETS_CLOUDFRONT_URL}/maps/${id}/thumbnail.png?${updatedAt}`;
